module.exports = require("lodash.isnumber");